import { render } from "./ListeApprovisionnementPage.vue?vue&type=template&id=3df56ed1&ts=true"
import script from "./ListeApprovisionnementPage.vue?vue&type=script&lang=ts"
export * from "./ListeApprovisionnementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__